import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
export var backToTopBehavior = function backToTopBehavior() {
  Alpine.data('backToTop', function () {
    return {
      shown: false,
      init: function init() {
        this.shown = false;
      }
    };
  });
};